import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";

function ConfirmationDialog({ entityName, entityType = "פריט", open, onClose, onConfirm, isPending }) {
    return (
        <Dialog open={open} dir="rtl">
            <DialogTitle>אישור מחיקה</DialogTitle>
            <DialogContent> 
                האם אתה בטוח שברצונך למחוק את ה{entityType} "{entityName || ''}"?
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    ביטול
                </Button>
                <Button 
                    onClick={onConfirm}  
                    color="error" 
                    variant="contained" 
                    disabled={isPending}
                >
                    {isPending ? 'מוחק...' : 'מחק'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmationDialog;